// @dynamic
export class BirthIdValidator {
    static readonly BIRTH_ID_MAX_LENGTH = 9;

    static isBirthIdValid(input) {
        input = String(input);
        if(input.length !== BirthIdValidator.BIRTH_ID_MAX_LENGTH) return false;

        let sum = BirthIdValidator.mergeInputWithMask(input, BirthIdValidator.BIRTH_ID_MAX_LENGTH);
        return sum%10 == 0;
    }

    static isPassportNumberValid(passportNumber) {
        return passportNumber.length > 0 && passportNumber.length <= 16;
    }

    static getCheckDigit(input: string|number): number {
        input = String(input);
        let sum = BirthIdValidator.mergeInputWithMask(input);
        return sum > 0 ? 10 - (sum%10) : 0;
    }

    static concatCheckDigit(input: string|number): string {
        input = String(input);
        let digit = BirthIdValidator.getCheckDigit(input);
        return `${input}${digit}`;
    }

    static fillMaskArr(numLength: number): Array<(v: number) => number> {
        return new Array(numLength).fill(v => v%2 ? 2 : 1);
    }

    static mergeInputWithMask(input: string, limit:number = -1): number {
        let numLength = input.length;
        let mask = BirthIdValidator.fillMaskArr(numLength);
        let sum = 0,calc = 0;
        let calcStr = "";
        limit = limit === -1 ? numLength : limit;
        for(let i=0;i<limit;i++){
            calc = Number(input[i]) * mask[i](i);
            calcStr = calc.toString();
            if(calcStr.length == 2){
                calc = Number(calcStr[0]) + Number(calcStr[1]);
            }
            sum += calc;
        }
        return sum;
    }

}